// (function () {
//     'use strict';

//     angular.module("imApp").factory("travelWageMenuService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getTravelWageMenu: function (parms) {
//                 return $ihttp.post({
//                     method: 1491,
//                     parameters: parms || {}
//                 });
//             },
//             deleteItem: function (menu) {
//                 return $ihttp.post({
//                     method: 1493,
//                     parameters: menu
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
